import { convertToGraphqlBounds } from "@/lib/utils/map";
import {
  AgeGroup,
  Gender,
  useGetMediaProductsInBoundsQuery,
} from "@/services/graphql/generated";

interface UseMediaProductsInBoundsParams {
  bounds: google.maps.LatLngBounds | null;
  isMyProduct: boolean;
  skip?: boolean;
  targetCategories?: string;
  targetTypes?: string;
  trafficValue?: number;
  inGender?: Gender[];
  inAge?: AgeGroup[];
  isMyBookmark?: boolean;
  adFeePerMonth?: number;
  adTypes?: string;
}

export function useMediaProductsInBounds({
  bounds,
  isMyProduct,
  skip = false,
  targetCategories,
  targetTypes,
  trafficValue,
  inGender,
  inAge,
  isMyBookmark,
  adFeePerMonth,
  adTypes,
}: UseMediaProductsInBoundsParams) {
  const { data, loading, error, refetch } = useGetMediaProductsInBoundsQuery({
    skip: skip,
    variables: {
      bounds: bounds ? convertToGraphqlBounds(bounds) : undefined,
      isMyProduct,
      targetCategories,
      targetTypes,
      trafficValue,
      inGender,
      inAge,
      isMyBookmark,
      adFeePerMonth,
      adTypes,
    },
  });

  const products = data?.mediaProductsInBounds?.products ?? [];
  const medias = data?.mediasInBounds?.medias ?? [];

  return {
    products,
    medias,
    loading,
    error,
    refetch,
  };
}
